import {Component, QueryList, ViewChildren} from '@angular/core';
import {MatCheckbox, MatCheckboxModule} from '@angular/material/checkbox';
import {LabelResponse} from '@backend';
import {FieldTypeConfig, FormlyAttributes} from '@ngx-formly/core';
import {FieldType} from '@ngx-formly/material';
import {FormlyMatFormFieldModule} from '@ngx-formly/material/form-field';
import {IdentifierHipaa, IdentifierHipaaOptions} from '@shared/labels/identifier-hipaa';
import {SensitivityLevel, SensitivityLevelLabels} from '@shared/labels/sensitivity-level';

// stolen from https://github.com/ngx-formly/ngx-formly/blob/main/src/ui/material/multicheckbox/src/multicheckbox.type.ts

@Component({
  selector: 'app-hipaa-identifier-checklist',
  imports: [MatCheckboxModule, FormlyMatFormFieldModule, FormlyAttributes],
  templateUrl: './hipaa-identifier-checklist.component.html',
  styleUrl: './hipaa-identifier-checklist.component.scss',
})
export class HipaaIdentifierChecklistComponent extends FieldType<FieldTypeConfig> {
  @ViewChildren(MatCheckbox) checkboxes!: QueryList<MatCheckbox>;

  override defaultOptions = {
    props: {
      hideFieldUnderline: true,
      array: true,
      floatLabel: 'always' as const,
      color: 'accent' as const, // workaround for https://github.com/angular/components/issues/18465
    },
  };

  public checkOptions = (<LabelResponse[]>Object.keys(IdentifierHipaaOptions).map(key => IdentifierHipaaOptions[key]))
    .filter(label => label.sensitivity_level_id != SensitivityLevel.NA)
    .sort((a, b) => a.display_order - b.display_order);
  public slids = SensitivityLevelLabels;
  public short_slids = {na: 'N/A', none: 'NONE', 'de-id': 'DE-ID', lds: 'LDS', hsd: 'HSD'};

  onChange(value: any, checked: boolean) {
    this.formControl.markAsDirty();
    if (this.props.type === 'array') {
      this.formControl.patchValue(
        checked
          ? [...(this.formControl.value || []), value]
          : [...(this.formControl.value || [])].filter(o => o !== value),
      );
    } else {
      this.formControl.patchValue({...this.formControl.value, [value]: checked});
    }
    this.formControl.markAsTouched();
  }

  override onContainerClick() {}

  isChecked(option: LabelResponse) {
    const value = this.formControl.value;

    return value && (this.props.type === 'array' ? value.includes(option.id) : value[option.id]);
  }

  isDisabled(option: LabelResponse) {
    const value = this.formControl.value;
    if (!value) return false;
    if (this.props.type === 'array') {
      return (
        (option.id === IdentifierHipaa.NONE &&
          value.some(other_option => other_option !== IdentifierHipaa.NONE && other_option !== IdentifierHipaa.NA)) ||
        (option.id !== IdentifierHipaa.NONE && value.includes(IdentifierHipaa.NONE))
      );
    } else {
      return (
        (option.id === IdentifierHipaa.NONE &&
          Object.keys(value).some(
            other_option => other_option !== IdentifierHipaa.NONE && other_option !== IdentifierHipaa.NA,
          )) ||
        (option.id !== IdentifierHipaa.NONE && value[IdentifierHipaa.NONE])
      );
    }
  }
}
